import {ChangeDetectorRef, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {DynamicHeadingService} from './dynamic-heading.service';
import {Observable} from 'rxjs';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {isNotNullable, PageMetaService} from '@spartacus/core';
import {filter, map} from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'dcp-dynamic-heading',
  templateUrl: './dynamic-heading.component.html',
  styleUrls: ['./dynamic-heading.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DynamicHeadingComponent implements OnInit {
  title$: Observable<string>;
  public heading: string = '';

  constructor(
    protected dynamicHeadingService: DynamicHeadingService,
    protected changeDetectorRef: ChangeDetectorRef,
    private pageMetaService: PageMetaService,
  ) {
  }

  ngOnInit(): void {
    this.dynamicHeadingService.getHeading$().pipe(untilDestroyed(this)).subscribe((value) => {
      this.heading = value;
      this.changeDetectorRef.detectChanges();
    });
    this.title$ = this.pageMetaService.getMeta().pipe(
      filter(isNotNullable),
      map((meta) => (meta.heading || meta.title) ?? '')
    );
  }
}
